import { Dic } from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
export const rangeOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: false,
    index: false,
    radio: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    size: "small",
    maxHeight: "100%",
    labelWidth: "140px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: "550px",
    emptyText: "暂无数据",
    column: [
      // {
      //   label: "",
      //   prop: "personnelCode",
      //   align: "right",
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   editDisabled: false,
      //   viewDisplay: false,
      //   overHidden: true,
      //   formslot: true,
      //   columnWidth: 50
      // },
      {
        label: "姓名",
        prop: "name",
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        search: false,
        clearable: true,
        span: 12
      },
      {
        label: "工号",
        prop: "workNo",
        search: false,
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        clearable: true,
        span: 12
      },
      {
        label: "部门",
        prop: "departmentName",
        search: false,
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        // searchPlaceholder: '请输入部门',
        span: 12
      },
      {
        label: "岗位",
        prop: "position",
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        search: false,
        span: 12,
        formatter: function (row, value) {
          return value ? value : '暂无';
        }
      },
      {
        label: "是否在职",
        prop: "onJob",
        type: "select",
        search: false,
        span: 12,
        dicData: [
          {
            label: "全部",
            value: -1
          },
          {
            label: "在职",
            value: 1
          },
          {
            label: "离职",
            value: 0
          },
          {
            label: "未知",
            value: 4
          }
        ],
        formatter: function (row, value) {
          let str = "";
          if (value == -1) {
            str = "全部";
          }
          if (value == 1) {
            str = "在职";
          }
          if (value == 0) {
            str = "离职";
          }
          if (value == 4 || value == null) {
            str = "未知";
          }
          return str;
          // return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: "电话",
        // align: 'center',
        prop: "phone",
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        search: false,
        searchPlaceholder: "请输入电话",
        span: 12,
        formatter: function (row, value) {
          return value ? value : '暂无';
        }
      }
    ]
  };
};
